
export const toDigits : string = (fromNum : number, amount) => {
    return ("0" + fromNum).slice(-amount);
};
